import React from 'react';
import './Presentation.css';

export default function Presentation() {
  return (
    <section className="presentation">
      <h2>Notre histoire</h2>

      <div className="presentation-content">
        <div className="presentation-image">
          <img src={require('../../assets/images/presentation.png')} alt="NEXUS SOLUTIONS Abidjan" loading="lazy" />
        </div>
        <div className="presentation-text">
          <p>
            <strong>NEXUS SOLUTIONS</strong> est une agence digitale fondee a Abidjan.
            Nous aidons les entrepreneurs et les PME ivoiriennes a construire leur presence
            en ligne : sites web, applications mobiles et boutiques e-commerce adaptes
            au marche local.
          </p>
          <p>
            Nous connaissons les realites du terrain : les clients qui paient par
            Orange Money ou Wave, les sites qui doivent charger rapidement sur une
            connexion 3G, les budgets qui ne sont pas ceux d'une multinationale.
            Chaque solution que nous livrons est pensee pour le contexte ivoirien,
            pas un template coupe-colle d'un modele etranger.
          </p>
          <p>
            Depuis notre creation, nous avons accompagne plus de 15 clients dans
            leur transformation digitale. Chaque projet est une collaboration directe
            avec vous : pas d'intermediaires, pas de surprises sur la facture.
          </p>
        </div>
      </div>
    </section>
  );
}
